(function () {
    'use strict';

    angular
        .module('cloudApp')
        .controller('InviteController', InviteController);

    InviteController.$inject = ['$scope', '$rootScope', '$uibModalInstance', '$stateParams', 'entity', 'InviteSendService', '$window', 'AlertService', 'Account'];

    function InviteController($scope, $rootScope, $uibModalInstance, $stateParams, entity, InviteSendService, $window, AlertService, Account) {
        var vm = this;

        vm.params = entity;

        vm.account = {};

        vm.clear = function clear() {
            $uibModalInstance.dismiss('cancel');
        };

        vm.invite = function () {
            vm.isSaving = true;
            InviteSendService.sendInvite(vm.account, vm.params.company, vm.params.instance).then(function (response) {
                vm.success = 'OK';
                $uibModalInstance.close(true);
                AlertService.success('Invitation sent');
            }).catch(function (response) {
                    vm.error = 'ERROR';
                    AlertService.error(response);
                });
        };

        function getAccountThen (account) {
            vm.account = account.data;
            vm.account.email = '';
        }

        Account.get().$promise
            .then(getAccountThen);

        vm.inviteAdmin = function () {
            vm.isSaving = true;
            InviteSendService.sendInviteAdmin(vm.account, vm.params.company, vm.params.instance).then(function (response) {
                vm.success = 'OK';
                $window.open($stateParams.dbhawkUrl+"/?cuser="+vm.account.login, '_blank');
                $uibModalInstance.close(true);

            }).catch(function (response) {
                vm.error = 'ERROR';
                vm.isSaving = false;
            });
        };
    }
})();
